<template>
  <div id="ag-grid-lists">
    <div id="div-with-loading" class="vs-con-loading__container">
      <vs-tabs class="lists-page custom-vs-tabs slot-border-top">
        <vs-tab label="CNIC Promos" id="cnic" v-if="!disableCNICFlag">
          <div class="tab-text">
            <CnicPromoListComponent></CnicPromoListComponent>
          </div>
        </vs-tab>

        <vs-tab label="Tucows Promos" id="tucows">
          <div class="tab-text">
            <TucowsPromoListComponent></TucowsPromoListComponent>
          </div>
        </vs-tab>

        <vs-tab label="Internal Promos" id="internal">
          <div class="tab-text">
            <InternalPromoListComponent></InternalPromoListComponent>
          </div>
        </vs-tab>

        <vs-tab label="MIS" id="mis">
          <div class="tab-text">
            <MisPromoListComponent></MisPromoListComponent>
          </div>
        </vs-tab>

        <vs-tab label="Expired">
          <vs-tabs class="lists-expired-tabs">
            <vs-tab label="CNIC" v-if="!disableCNICFlag">
              <div class="tab-text">
                <CnicPromoListComponent expired></CnicPromoListComponent>
              </div>
            </vs-tab>

            <vs-tab label="Tucows">
              <div class="tab-text">
                <TucowsPromoListComponent expired></TucowsPromoListComponent>
              </div>
            </vs-tab>

            <vs-tab label="Internal">
              <div class="tab-text">
                <InternalPromoListComponent expired></InternalPromoListComponent>
              </div>
            </vs-tab>

            <vs-tab label="MIS">
              <div class="tab-text">
                <MisPromoListComponent expired></MisPromoListComponent>
              </div>
            </vs-tab>
          </vs-tabs>
        </vs-tab>
      </vs-tabs>
    </div>

    <EditCnicPromo></EditCnicPromo>

    <EditTucowsPromo></EditTucowsPromo>

    <EditInternalPromo></EditInternalPromo>

    <EditMISPromo></EditMISPromo>

  </div>
</template>

<script>
import CnicPromoListComponent from "@/components/ag-grid-tables/promos/CnicPromoListComponent.vue";
import TucowsPromoListComponent from "@/components/ag-grid-tables/promos/TucowsPromoListComponent.vue";
import InternalPromoListComponent from "@/components/ag-grid-tables/promos/InternalPromoListComponent.vue";
import MisPromoListComponent from "@/components/ag-grid-tables/promos/MISPromoListComponent.vue";

import EditCnicPromo from "@/components/ag-grid-tables/promos/EditCNICPromo.vue";
import EditTucowsPromo from "@/components/ag-grid-tables/promos/EditTucowsPromo.vue";
import EditInternalPromo from "@/components/ag-grid-tables/promos/EditInternalPromo.vue";
import EditMISPromo from "@/components/ag-grid-tables/promos/EditMISPromo.vue";

export default {
  name: 'PromoLists',
  components: {
    CnicPromoListComponent,
    TucowsPromoListComponent,
    InternalPromoListComponent,
    MisPromoListComponent,
    EditCnicPromo,
    EditTucowsPromo,
    EditInternalPromo,
    EditMISPromo
  },
  mounted() {
    var self = this;

    // TODO: Land on the respective tabs based on notification
    // this.$nextTick(() => {
    //   if(self.$store.getters.getSwitchToTab) {
    //     document.querySelectorAll('.vs-tabs--li.activeChild')[0].classList.remove('activeChild');
    //     document.getElementById(self.$store.getters.getSwitchToTab).click();
    //     self.$store.dispatch('setSwitchToTab', null);
    //   }
    // })
  },
  computed: {
    disableCNICFlag() {
			return this.$store.getters.getDisableCNICFlag;
		}
  }
};
</script>